export default __webpack_public_path__ + "static/media/AR-9.20826f30.jpg";